
function useSaleReconciliationReport(saleItem, packageItem) {
    const rawCardInfoList = [
        {
            name: 'Tổng số đơn hàng',
            value: saleItem?.totalSale + packageItem?.totalSale,
            unit: '',
            color: '#E6196E',
            icon: 'fa-solid fa-box',
            formula: () => [saleTotalIndex, packageTotalIndex],
            type: 'card',
            show: true,
        },
        {
            name: 'Tổng doanh thu',
            value: saleItem?.amountSale + packageItem?.amountSale,
            unit: 'VNĐ',
            color: '#FE6358',
            icon: 'fa-solid fa-sack-dollar',
            formula: () => [saleAmountIndex, packageAmountIndex],
            type: 'card',
            show: true,
        },
        {
            name: 'Tổng hoa hồng',
            value: saleItem?.estimatedSaleCommissionAmount + packageItem?.estimatedPackageCommissionAmount,
            unit: 'VNĐ',
            color: '#30BD6F',
            icon: 'fa-solid fa-badge-dollar',
            formula: () => [energyCommissionIndex, landlordCommissionIndex, saleCommissionIndex, packageCommissionIndex],
            type: 'card',
            show: true,
        },
        {
            name: 'Hoa hồng tiền điện',
            value: 0,
            unit: 'VNĐ',
            color: '#3497FB',
            icon: 'fa-solid fa-bolt',
            formula: () => [energyCommissionIndex],
            type: 'card',
            show: true,
        },
        {
            name: 'Hoa hồng phát triển mặt bằng',
            value: 0,
            unit: 'VNĐ',
            color: '#FFAA24',
            icon: 'fa-solid fa-chart-mixed',
            formula: () => [landlordCommissionIndex],
            type: 'card',
            show: true,
        },
        {
            name: 'Số đơn hàng',
            value: saleItem?.totalSale,
            unit: '',
            color: '#E6196E',
            formula: () => [saleTotalIndex],
            type: 'sale-chart',
            show: true,
        },
        {
            name: 'Số doanh thu',
            value: saleItem?.amountSale,
            unit: 'VNĐ',
            color: '#FE6358',
            formula: () => [saleAmountIndex],
            type: 'sale-chart',
            show: true,
        },
        {
            name: 'Tỷ lệ hoa hồng',
            value: saleItem?.estimatedSaleCommissionRate * 100,
            unit: '%',
            color: '#FFAA24',
            formula: () => [saleCommissionRateIndex],
            type: 'sale-chart',
            show: true,
        },
        {
            name: 'Số tiền hoa hồng',
            value: saleItem?.estimatedSaleCommissionAmount,
            unit: 'VNĐ',
            color: '#30BD6F',
            formula: () => [saleCommissionIndex],
            type: 'sale-chart',
            show: true,
        },
        {
            name: 'Số đơn hàng',
            value: packageItem?.totalSale,
            unit: '',
            color: '#E6196E',
            formula: () => [packageTotalIndex],
            type: 'group-chart',
            show: true,
        },
        {
            name: 'Số doanh thu',
            value: packageItem?.amountSale,
            unit: 'VNĐ',
            color: '#FE6358',
            formula: () => [packageAmountIndex],
            type: 'group-chart',
            show: true,
        },
        {
            name: 'Tỷ lệ hoa hồng',
            value: packageItem?.estimatedPackageCommissionRate * 100,
            unit: '%',
            color: '#FFAA24',
            formula: () => [packageCommissionRateIndex],
            type: 'group-chart',
            show: true,
        },
        {
            name: 'Số tiền hoa hồng',
            value: packageItem?.estimatedPackageCommissionAmount,
            unit: 'VNĐ',
            color: '#30BD6F',
            formula: () => [packageCommissionIndex],
            type: 'group-chart',
            show: true,
        },
    ];

    let currentIndex = 1;
    const indexMap = {};

    rawCardInfoList.forEach((card, i) => {
        if (card.show) {
            indexMap[i] = currentIndex++;
        }
    });

    const findIndex = (type, name) => {
        const index = rawCardInfoList.findIndex((card) => card.type === type && card.name === name && card.show);
        return index !== -1 ? indexMap[index] || 0 : 0;
    };

    const saleTotalIndex = findIndex('sale-chart', 'Số đơn hàng');
    const saleAmountIndex = findIndex('sale-chart', 'Số doanh thu');
    const saleCommissionRateIndex = findIndex('sale-chart', 'Tỷ lệ hoa hồng');
    const saleCommissionIndex = findIndex('sale-chart', 'Số tiền hoa hồng');
    const packageTotalIndex = findIndex('group-chart', 'Số đơn hàng');
    const packageAmountIndex = findIndex('group-chart', 'Số doanh thu');
    const packageCommissionRateIndex = findIndex('group-chart', 'Tỷ lệ hoa hồng');
    const packageCommissionIndex = findIndex('group-chart', 'Số tiền hoa hồng');
    const energyCommissionIndex = findIndex('card', 'Hoa hồng tiền điện');
    const landlordCommissionIndex = findIndex('card', 'Hoa hồng phát triển mặt bằng');

    const cardInfoList = rawCardInfoList
        .filter((card) => card.show)
        .map((card, i) => {
            const formulaIndexes = card
                .formula()
                .filter((index) => index !== 0 && index !== undefined);
            return {
                ...card,
                descriptionValue:
                    formulaIndexes.length > 1
                        ? `${indexMap[i]}=${formulaIndexes.join('+')}`
                        : `${formulaIndexes[0]}`,
            };
        });

    return {
        cardInfoList,
        indexes: {
            saleTotalIndex,
            saleAmountIndex,
            saleCommissionRateIndex,
            saleCommissionIndex,
            packageTotalIndex,
            packageAmountIndex,
            packageCommissionRateIndex,
            packageCommissionIndex,
            energyCommissionIndex,
            landlordCommissionIndex,
        },
    };
}

export default useSaleReconciliationReport;